/**
 * This file provides typing for objects returned by the Bex Api
 */
/* tslint:disable */
export enum PropertyFilterType {
  CLASS = "class",
  PRICE = "price",
  LODGING = "lodging"
}
